/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_S5Inputs */

const en_tut_wb_s5 = /** @type {(inputs: Tut_Wb_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Ekspor** saves the board as SVG or PNG.`)
};

const id_tut_wb_s5 = /** @type {(inputs: Tut_Wb_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Ekspor** menyimpan papan sebagai SVG atau PNG.`)
};

/**
* | output |
* | --- |
* | "**Ekspor** saves the board as SVG or PNG." |
*
* @param {Tut_Wb_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_s5 = /** @type {((inputs?: Tut_Wb_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_s5(inputs)
	return en_tut_wb_s5(inputs)
});